
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { COMPANY_LIST } from "@/constant";
import {
  searchCustomer,
} from "@/api/customer";
import {
  getPiCombinedUnit,
  getSupplierProduct,
  putPiCombinedUnit,
} from "@/api/proforma";
import { getSuppliersList } from "@/api/inquiry";
@Component({
  name: "ModifyDiscounts",
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "创建供应商扣款" }) private title: "";

  @Watch("show", { immediate: true })
  private async watchData() {
    // this.getPiCombinedUnit();
  }
  private form = {} as any;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public tableCol = [
    {
      label: "年度索赔号",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false,
    },
    {
      label: "供应商",
      prop: "supplierId",
      key: "supplierId",
      type: "select",
      value: "",
      placeholder: "",
      remote_method: this.getSuppliersList,
      remote: true,
      clearable: true,
      options: [],
      resetKey: { label: "abbreviation", value: "id" }
    },
    {
      label: "包干期限",
      prop: "shipmentQuantity",
      key: "shipmentQuantity",
      show: true,
      disabled: false,
      type: "dateTimePicker",
    },
    {
      label: "包干协议号",
      prop: "deliveryQuantity",
      key: "deliveryQuantity",
      show: true,
      disabled: false,
      type: "input",
    },
    {
      label: "签约日期",
      prop: "deliveryChineseUnit",
      key: "deliveryChineseUnit",
      show: true,
      disabled: false,
      type: "datetime",
    },
    {
      label: "对应开票金额",
      prop: "shipmentChineseUnit",
      key: "shipmentChineseUnit",
      show: true,
      disabled: false,
      type: "input",
    },
    {
      label: "比例",
      prop: "deliveryEnglishUnit",
      key: "deliveryEnglishUnit",
      show: true,
      disabled: false,
      type: "input",
    },
    {
      label: "年度索赔包干金额",
      prop: "shipmentEnglishUnit",
      key: "shipmentEnglishUnit",
      show: true,
      disabled: false,
      type: "input",
    },
    {
      label: "备注",
      prop: "shipmentEnglishUnit",
      key: "shipmentEnglishUnit",
      show: true,
      disabled: false,
      type: "textarea",
    },
  ] as any;

  private list = [
    {
      label: "公司",
      prop: "company",
      key: "company",
      type: "select",
      placeholder: "请选择公司",
      clearable: true,
      maxlength: 100,
      rules: {
        required: true,
        message: "请选择公司",
        trigger: "change",
      },
      options: COMPANY_LIST,
    },
    {
      label: "客户",
      prop: "customerId",
      key: "customerId",
      type: "select",
      value: "",
      placeholder: "请选择客户",
      remote: true,
      remote_method: this.getCustomer,
      clearable: true,
      options: [],
      rules: {
        required: true,
        message: "请选择客户",
        trigger: "change",
      },
      labelKey: "abbreviation",
      valueKey: "id",
    },
  ];
  private close() {
    this.$emit("update:show", false);
  }
  private open() {
    this.$emit("update:show", true);
  }
  private async submitForm(): Promise<void> {
    this.putPiCombinedUnit();
  }
  private async getCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.list[1].options = res;
  }
  private onSelectionChange(rows: any[]) {
    console.log(rows);
  }
  public async handleDelete(scope) {
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000,
    });
  }
  private async getSuppliersList(name = "") {
    const res: any = await this.getSuppliers(name);
    this.tableCol[1].options = res;
  }

  private async getSuppliers(name = "") {
    const res: any = await getSuppliersList({ abbreviation: name });
    return res;
  }

  // 更新组合单位
  private async putPiCombinedUnit() {
    const {
      hqProductName,
      supplier,
      shipmentQuantity,
      deliveryQuantity,
      deliveryChineseUnit,
      shipmentChineseUnit,
      deliveryEnglishUnit,
      shipmentEnglishUnit,
    } = this.form;
    let params = {
      hqProductName,
      supplierAbbr: supplier,
      shipmentQuantity,
      deliveryQuantity,
      deliveryChineseUnit,
      shipmentChineseUnit,
      deliveryEnglishUnit,
      shipmentEnglishUnit,
    };
    try {
      await putPiCombinedUnit(this.form.id, params);
      this.$notify({
        title: "成功",
        message: "创建成功",
        type: "success",
        duration: 2000,
      });
      this.close();
      this.$emit("success", false);
    } catch {}
  }
  private async getPiCombinedUnit() {
    const res: any = await getPiCombinedUnit(this.form.id);
    this.getSupplierProduct(res.supplierId);
  }
  private async getSupplierProduct(supplierId) {
    const res: any = await getSupplierProduct(supplierId, {
      hqProductName: this.form.hqProductName,
    });
    this.$set(this.form, "shipmentChineseUnit", res.chineseUnit || "");
    this.$set(this.form, "shipmentEnglishUnit", res.englishUnit || "");
    this.$set(this.form, "shipmentQuantity", 1);
    this.$set(this.form, "deliveryQuantity", 1);
  }
}
